// extracted by mini-css-extract-plugin
export var backdropBlur = "_kg-0";
export var contentCard = "_kg-5";
export var frame = "_kg-2";
export var image = "_kg-4";
export var imagePane = "_kg-3";
export var modal = "_kg-1";